/* global moment:false */
(function() {
    'use strict';

    enquiryService.$inject = ['$http'];
    angular
        .module('app.enquiry')
        .factory('enquiryService', enquiryService);

    /* @ngInject */
    function enquiryService($http) {
        var service = {
            getEnquiryItems:getEnquiryItems,
            addProduct: addProduct,
            deleteProduct: deleteProduct
        };

        return service;

        function getEnquiryItems(enquiryId) {
            return $http.get("/umbraco/api/enquiry/items?enquiryid=" + enquiryId)
                .then(function (response) {
                    if (response.data) {
                        return response.data;
                    }
                    return null;
                });
        };

        function addProduct(enquiryId, sku, pageId) {
            var url = "/umbraco/api/enquiry/addenquiryitem"
            var enquiryItemCommand = {
                enquiryId: enquiryId,
                sku : sku,
                pageId: pageId
            };

            return $http.post(url, enquiryItemCommand,{
                headers: { "Content-Type": "application/json; charset=UTF-8" }
            });
        };

        function deleteProduct(enquiryId, sku) {
            var url = "/umbraco/api/enquiry/DeleteEnquiryItem?enquiryId="+ enquiryId +"&sku="+ sku;
            return $http.delete(url);
        };
    }
})();